import { FormControl, InputLabel } from "@mui/material";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { WhiteInput } from "../../../components/Inputs/InputText";
import { BlueHoverButton } from "../../../components/Inputs/BlueHoverButton";
import styles from './SolicitacaoFiscalizacaoAnalise.module.css';
import Lista from "../../../components/Lista";
import servSolicitacaoFiscalizacao from "../../../services/login/servSolicitacaoFiscalizacao";
import { columnsSolicitacaoFiscalizacaoAnalise } from "./Lista";
import Popup from "../../../components/Popup";
import ResultadoAnalise from "../ResultadoAnalise";

const SolicitacaoFiscalizacaoAnalise = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [filtro, setFiltro] = useState("");
  const [openAnaliseFiscalizacao, setOpenAnaliseFiscalizacao] = useState(false);
  const [recordForView, setRecordForView] = useState(null);
  const [analisesSolicitacao, setAnalisesSolicitacao] = useState([]);

  const analises = useSelector((state) => state.analises);

  const onClickPesquisar = async () => {
    try {

      setIsLoading(true);

      const data = await servSolicitacaoFiscalizacao.ListarSolicitacoesFiscalizacaoAnalise(analises.codigoSolicitacaoFiscalizacao, filtro);

      let analiseSolic = data.Content;

      analiseSolic.map((analise) => {
        analise.id = analise.Id
      });

      setAnalisesSolicitacao(analiseSolic);

      setIsLoading(false);

    } catch (err) {
      setIsLoading(false);
    }
  }

  useEffect(() => {

    const recuperarAnalisesAnteriores = async () => {
      try {
        setIsLoading(true);

        const data = await servSolicitacaoFiscalizacao.ListarSolicitacoesFiscalizacaoAnalise(analises.codigoSolicitacaoFiscalizacao, "");

        let analiseSolic = data.Content;

        analiseSolic.map((analise) => {
          analise.id = analise.Id;
        })

        setAnalisesSolicitacao(analiseSolic);

        setIsLoading(false);
      } catch (err) {
        setIsLoading(false);
      }
    }

    if (analises.codigoSolicitacaoFiscalizacao) {
      recuperarAnalisesAnteriores();
    }

  }, [analises]);

  return (
    <div className={styles.solicitacaoContainer}>
      <h2 style={{ margin: 0 }}>Análises da solicitação de fiscalização</h2>

      <div className={styles.solicitacaoFiltros}>
        <FormControl>
          <InputLabel shrink style={{ color: "#B8B8B8" }}>Data de apresentação</InputLabel>
          <WhiteInput
            value={filtro}
            onChange={(e) => setFiltro(e.target.value)}
            type="date"
            id="pesquisa-data"
            sx={{ width: "500px", marginRight: "10px" }}
          />
        </FormControl>
        <BlueHoverButton onClick={onClickPesquisar} variant="contained" style={{ marginTop: "15px" }} >
          Pesquisar
        </BlueHoverButton>
      </div>

      <div>
        <Lista
          columns={columnsSolicitacaoFiscalizacaoAnalise}
          onDblClick={setOpenAnaliseFiscalizacao}
          setSelectedData={setRecordForView}
          rows={analisesSolicitacao}
          hideFooter={true}
          autoHeight={true}
        />
      </div>

      <Popup title="Análise da solicitação de fiscalização" openPopup={openAnaliseFiscalizacao} setOpenPopup={setOpenAnaliseFiscalizacao} >
        <ResultadoAnalise
          record={recordForView}
          setOpen={setOpenAnaliseFiscalizacao}
        />
      </Popup>
    </div>
  )
}

export { SolicitacaoFiscalizacaoAnalise }